import { createSlice } from '@reduxjs/toolkit'

export const BonusRules = createSlice({
  name: 'BonusRules',
  initialState: {
    BonusRules: {},
    loading: false,
  },
  reducers: {
    setBonusRules: (state, action) => ({
      ...state,
      BonusRules: action.payload,
    }),
    setBonusLoading: (state, action) => {
      state.loading = action.payload
    },
  },
})

export const { setBonusRules, setBonusLoading } = BonusRules.actions

export default BonusRules.reducer
